import urls from 'utils/config';
import request from 'utils/request';
import {put, takeLatest} from 'redux-saga/effects';
import DashboardActionTypes from '../types';
import {fetchApplicationReportSuccess, fetchStatisticFailure} from '../actions';
// import {fetchApplicationReportSuccess, fetchFinancialReportSuccess, fetchStatisticFailure} from '../actions';

const {API_BASE_URL} = urls || {};

function fetchStatistics({path, applicationId, adminLevelId, courseIds}) {
    const url = `${API_BASE_URL}/statistics/${path}?${applicationId ? `applicationId=${applicationId}` : ''}${
        adminLevelId ? `&administrationLevelItemId=${adminLevelId}` : ''
    }${courseIds ? `&courseId=${courseIds}` : ''}`;
    return request({
        method: 'get',
        url,
    });
}

function* fetchApplicationReport({payload}) {
    const { applicationId, adminLevelId, courseIds } = payload;
    const response = yield fetchStatistics({path: 'application-report', applicationId, adminLevelId, courseIds});
    if (response.success) {
        yield put(fetchApplicationReportSuccess(response.raw));
    } else {
        yield put(fetchStatisticFailure(response.message));
    }
}

// function* fetchFinancialReport({payload}) {
//     const { applicationId, adminLevelId, courseIds } = payload;
//     const response = yield fetchStatistics({path: 'financial-report', applicationId, adminLevelId, courseIds});
//     if (response.success) {
//         yield put(fetchFinancialReportSuccess(response.raw));
//     } else {
//         yield put(fetchStatisticFailure(response.message));
//     }
// }

export function* getStatistics() {
    yield takeLatest(DashboardActionTypes.FETCH_DASHBOARD_STATISTICS, fetchApplicationReport);
    // yield takeLatest(DashboardActionTypes.FETCH_DASHBOARD_STATISTICS, fetchFinancialReport);
}
